import { mergeArrayOfUnnormalizedObjects } from "#src/lib/gql/index.ts";

export const defaultTypePolicies = {
  AcceptTermsMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Account: { keyFields: ["id"] },
  ActivitiesInterface: { keyFields: ["id"], fields: { reactions: { merge: mergeArrayOfUnnormalizedObjects } } },
  ActivityReactionType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Age: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AirdropPromotionalEvent: { keyFields: ["slug"] },
  AlternativeRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Announcement: { keyFields: ["id"] },
  AnnouncementNotification: { keyFields: ["id"] },
  AnonymousUser: { keyFields: ["id"] },
  AnyCardInterface: {
    keyFields: ["slug"],
    fields: { collectionScoringMatrix: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  AnyCardReward: { keyFields: ["id"] },
  AnyCardSubscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyCardWithPlayerGameScore: { keyFields: ["id"] },
  AnyContestantInterface: { keyFields: ["id"] },
  AnyConversionCreditReward: { keyFields: ["id"] },
  AnyGameInterface: { keyFields: ["id"] },
  AnyPlayerGameStatsInterface: { keyFields: ["id"] },
  AnyPlayerInterface: {
    keyFields: ["slug"],
    fields: {
      cardSupply: { merge: mergeArrayOfUnnormalizedObjects },
      news: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  AnyPlayerNewsUpdate: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyRewardConfigInterface: { keyFields: ["id"] },
  AnyRewardInterface: { keyFields: ["id"] },
  AppearanceBoostShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  AppearanceInterface: { keyFields: ["id"] },
  AppearanceRule: { keyFields: ["id"] },
  ApplePurchaseToken: { keyFields: ["id"] },
  AuctionNotification: { keyFields: ["id"] },
  AuctionReminder: { keyFields: ["id"] },
  AuthorizationRequest: { keyFields: ["id"] },
  AutoClaimNotification: { keyFields: ["id"] },
  AvailableBalances: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageLastScore: { keyFields: ["id"] },
  AverageLastScoreInterface: { keyFields: ["id"] },
  AverageScoreOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageScoresRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BankAccountInterface: { keyFields: ["id"] },
  BankWithdrawal: { keyFields: ["id"] },
  BaseAverageLastScore: { keyFields: ["id"] },
  BaseWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballCard: {
    keyFields: ["slug"],
    fields: { collectionScoringMatrix: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  BaseballContestantType: { keyFields: ["id"] },
  BaseballPlayer: {
    keyFields: ["slug"],
    fields: {
      allAverageStats: { merge: mergeArrayOfUnnormalizedObjects },
      allTotalStats: { merge: mergeArrayOfUnnormalizedObjects },
      cardSupply: { merge: mergeArrayOfUnnormalizedObjects },
      news: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  BaseballPlayerGameScore: { keyFields: ["id"], fields: { detailedScore: { merge: mergeArrayOfUnnormalizedObjects } } },
  BaseballTeamGameStats: { keyFields: ["id"], fields: { stats: { merge: mergeArrayOfUnnormalizedObjects } } },
  BaseballUserSportProfile: {
    keyFields: ["id"],
    fields: { tournamentEligibilities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  BasketballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballContestantType: { keyFields: ["id"] },
  BasketballDivision: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballPlayerGameScore: {
    keyFields: ["id"],
    fields: { detailedScore: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  BasketballTeamGameStats: { keyFields: ["id"], fields: { stats: { merge: mergeArrayOfUnnormalizedObjects } } },
  BenchSort: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BidSource: { keyFields: ["id"] },
  BidToEarnReward: { keyFields: ["id"] },
  BidToEarnRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Blueprint: { keyFields: ["id"] },
  BoostLevel: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CaBankAccount: { keyFields: ["id"] },
  Card: { keyFields: ["slug"], fields: { collectionScoringMatrix: { merge: mergeArrayOfUnnormalizedObjects } } },
  CardBoost: { keyFields: ["id"] },
  CardBoostConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollection: {
    keyFields: ["slug"],
    fields: {
      bonusThresholds: { merge: mergeArrayOfUnnormalizedObjects },
      scoringMatrix: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  CardCollectionBonusThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionCard: { keyFields: ["id"] },
  CardCollectionCardScoreBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionNotification: { keyFields: ["id"] },
  CardCollectionRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionScoreIncrease: { keyFields: ["id"] },
  CardCollectionScoringMatrix: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionSlot: { keyFields: ["id"] },
  CardCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionsCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      displayedEditions: { merge: mergeArrayOfUnnormalizedObjects },
      editions: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  CardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardNotification: { keyFields: ["id"] },
  CardPack: {
    keyFields: ["slug"],
    fields: { sections: { merge: mergeArrayOfUnnormalizedObjects }, slots: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CardPackGroup: { keyFields: ["id"] },
  CardPackReward: { keyFields: ["id"] },
  CardPackSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      playingStatusOdds: { merge: mergeArrayOfUnnormalizedObjects },
      rankOdds: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  CardPackSlotPlayingStatusOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlotRankOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPacksRewardConfig: { keyFields: ["id"] },
  CardPull: { keyFields: ["id"] },
  CardPullCard: { keyFields: ["id"] },
  CardPullConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { revealCosts: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CardPullSource: { keyFields: ["id"] },
  CardRewardConfig: { keyFields: ["id"] },
  CardSample: { keyFields: ["id"] },
  CardSeasonSupply: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardSet: { keyFields: ["slug"] },
  CardShardRewardConfig: { keyFields: ["id"] },
  CardShardThresholdsPromotionalEvent: { keyFields: ["slug"] },
  CardShardsChest: { keyFields: ["id"], fields: { thresholds: { merge: mergeArrayOfUnnormalizedObjects } } },
  CardShardsChestThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { draws: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CardShardsChestThresholdDraw: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { probabilities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CardShardsChestThresholdProbability: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsReward: { keyFields: ["id"] },
  CardSource: { keyFields: ["id"] },
  CardStats: { keyFields: ["id"], fields: { highlightedStats: { merge: mergeArrayOfUnnormalizedObjects } } },
  CardUsageInterface: { keyFields: ["slug"] },
  CardXPGradeThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardsCountAsFirstOwnerRule: {
    keyFields: ["id"],
    fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CardsCountTask: {
    keyFields: ["id"],
    fields: {
      alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      thresholds: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  Cart: { keyFields: ["id"] },
  CartItem: { keyFields: ["id"] },
  CartPurchaseRewardPromotionalEvent: { keyFields: ["slug"] },
  CheckoutCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Club: { keyFields: ["slug"] },
  CoinReward: { keyFields: ["id"] },
  CoinRewardConfig: { keyFields: ["id"] },
  CollectionTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CommonAccount: { keyFields: ["id"] },
  CommonCardSwapShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CommonGameEndOfSeasonCountdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CommonPlayer: { keyFields: ["id"] },
  Competition: { keyFields: ["slug"] },
  CompetitionCardCollections: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionCardCollectionsStats: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionGames: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompletablePromotionalEvent: { keyFields: ["slug"] },
  CompletablePromotionalEventInterface: { keyFields: ["slug"] },
  CompleteCollectionsCountTask: {
    keyFields: ["id"],
    fields: {
      alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      thresholds: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  ComposeTeamBenchCard: { keyFields: ["id"] },
  ComposeTeamBenchCommonPlayer: { keyFields: ["id"] },
  ComposeTeamBenchObjectInterface: { keyFields: ["id"] },
  Config: { keyFields: ["id"] },
  ConfirmDeviceMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ConfirmEmailMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ConnectedOAuth: { keyFields: ["id"] },
  ConsumeEphemeralTokenMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Contestant: { keyFields: ["id"] },
  Contract: { keyFields: ["id"] },
  ConversionCredit: { keyFields: ["id"] },
  ConversionCreditCampaign: { keyFields: ["id"] },
  ConversionCreditNotification: { keyFields: ["id"] },
  ConversionCreditRewardConfig: { keyFields: ["id"] },
  CountByRarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Country: { keyFields: ["slug"] },
  Counts: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CreateOrUpdateSo5LineupMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  CreditCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CurrentUser: {
    keyFields: ["slug"],
    fields: {
      competitionCardCollections: { merge: mergeArrayOfUnnormalizedObjects },
      inGameCurrencyBalances: { merge: mergeArrayOfUnnormalizedObjects },
      myUnclaimedBoostedRewardConfigsByRarity: { merge: mergeArrayOfUnnormalizedObjects },
      podiums: { merge: mergeArrayOfUnnormalizedObjects },
      searchCardFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
      trophies: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  CurrentUserTaskWasUpdatedPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DailyActionTask: {
    keyFields: ["id"],
    fields: {
      alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      thresholds: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  DataPartner: { keyFields: ["slug"] },
  DateRangeSpecific: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DecisiveActionNotification: { keyFields: ["id"] },
  DecisiveEventInterface: { keyFields: ["id"] },
  DecisivePlayerPickerTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  DecisivePlayerPickerTaskAppearance: {
    keyFields: ["id"],
    fields: { decisiveStats: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  DecisivePurchaseNotification: { keyFields: ["id"] },
  Deck: { keyFields: ["slug"] },
  DeliverableItemInterface: { keyFields: ["slug"] },
  DeliverableItemOrder: { keyFields: ["id"] },
  DeliverableItemReward: { keyFields: ["id"] },
  DeliverableItemRewardConfig: { keyFields: ["id"] },
  DeliverableItemVariantsStocks: { keyFields: ["id"] },
  DeliverableItemsRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DeliverableWithCustomVariantShopItem: {
    keyFields: ["id"],
    fields: {
      cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects },
      variantStockCounts: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  DeliverableWithNoVariantShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  DepositPromotionalEvent: { keyFields: ["slug"] },
  DivisionChangeConfiguration: { keyFields: ["id"] },
  DropChallengeTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  EligibilityRules: { keyFields: ["id"] },
  EligibleCollectionRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EmailSubscription: { keyFields: ["slug"] },
  EmailSubscriptionPreferences: { keyFields: ["slug"] },
  EngineConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EnglishAuctionSource: { keyFields: ["id"] },
  EthBankWithdrawalIntent: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthMigration: { keyFields: ["id"] },
  EthereumAccount: { keyFields: ["id"] },
  EthereumBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumTransaction: { keyFields: ["id"] },
  Event: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ExchangeRate: { keyFields: ["id"] },
  ExperienceDeliverableItem: { keyFields: ["slug"] },
  ExperienceReward: { keyFields: ["id"] },
  ExperienceRewardConfig: { keyFields: ["id"] },
  ExternalDepositNotification: { keyFields: ["id"] },
  ExtraSwapShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  FaceLandmark: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FastWithdrawal: { keyFields: ["id"] },
  FastWithdrawalWithRates: { keyFields: ["id"] },
  FeaturedLeagues: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardContenders: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardGroups: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fee: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fiat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FiatWalletAccount: { keyFields: ["id"] },
  FixturePlayer: { keyFields: ["id"] },
  FootballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballContestantType: { keyFields: ["id"] },
  FootballConversionCredit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballGoalEvent: { keyFields: ["id"] },
  FootballManagerTask: { keyFields: ["id"] },
  FootballRewardShopItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballRoot: { keyFields: ["id"] },
  FootballSanctionCardEvent: { keyFields: ["id"] },
  FootballSo5NoCardRouteRoot: { keyFields: ["id"] },
  FootballTeamGameStats: { keyFields: ["id"], fields: { stats: { merge: mergeArrayOfUnnormalizedObjects } } },
  FootballUserSportProfile: {
    keyFields: ["id"],
    fields: { tournamentEligibilities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ForYouRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { featuredLeaguesWithUpcoming: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  FullWithdrawalRequest: { keyFields: ["id"] },
  GalleryCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Game: { keyFields: ["id"] },
  GameDay: { keyFields: ["id"] },
  GameOfBaseball: { keyFields: ["id"], fields: { scoresByInning: { merge: mergeArrayOfUnnormalizedObjects } } },
  GameOfBasketball: { keyFields: ["id"], fields: { scoresByQuarter: { merge: mergeArrayOfUnnormalizedObjects } } },
  GameWeeklyTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  GameWeeklyTaskInterface: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  GameWithCardsPreview: { keyFields: ["id"] },
  GameWithPlayerGameScoresPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GbBankAccount: { keyFields: ["id"] },
  HighScarcity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighScarcityStatuses: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighlightedStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HistoryTransactionInterface: { keyFields: ["id"] },
  IbanBankAccount: { keyFields: ["id"] },
  ImportedSo5Appearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyBalance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyNotification: { keyFields: ["id"] },
  InGameCurrencyPack: { keyFields: ["id"] },
  InGameCurrencyPurchasableItem: { keyFields: ["slug"] },
  InGameCurrencyReward: { keyFields: ["id"] },
  InGameCurrencyRewardConfig: { keyFields: ["id"] },
  InGameCurrencySource: { keyFields: ["id"] },
  IncompleteCardCollection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Injury: { keyFields: ["id"] },
  Inning: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  IntegerBySportType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  JerseyDeliverableItem: { keyFields: ["slug"] },
  JerseyShopItem: {
    keyFields: ["id"],
    fields: {
      cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects },
      variantStockCounts: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  JwtToken: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KlarnaPayinConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycDocumentRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycRequestNotification: { keyFields: ["id"] },
  LeaderboardRewardsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LevelUpShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  LeveledUpCard: { keyFields: ["id"] },
  ListedOnMarket: { keyFields: ["slug"] },
  Loan: { keyFields: ["id"] },
  LoanNotification: { keyFields: ["id"] },
  LoanableConfigRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoanableRoster: { keyFields: ["id"] },
  LoanedToken: { keyFields: ["id"] },
  LobbySection: { keyFields: ["slug"] },
  LobbyTile: { keyFields: ["id"] },
  Location: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoomAccount: { keyFields: ["id"] },
  ManagerProgressionNotification: { keyFields: ["id"] },
  ManagerTaskInterface: { keyFields: ["id"] },
  ManagerTeam: { keyFields: ["id"] },
  MangopayApplePayAuthorizationRequest: { keyFields: ["id"] },
  MangopayBankAccountOwnerAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayCreditCardAuthorizationRequest: { keyFields: ["id"] },
  MangopayKlarnaAuthorizationRequest: { keyFields: ["id"] },
  MangopayKycDocument: { keyFields: ["id"] },
  MangopayKycRequest: { keyFields: ["id"] },
  MangopayRemotePreAuthorizationStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRemoteTransactionStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRoot: {
    keyFields: ["id"],
    fields: {
      klarnaPayinConfig: { merge: mergeArrayOfUnnormalizedObjects },
      kycDocumentRequirements: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  MangopayUser: { keyFields: ["id"] },
  MangopayWalletTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayWithdrawal: { keyFields: ["id"] },
  MarketPromotionalEvent: { keyFields: ["slug"] },
  MarketRoot: {
    keyFields: ["id"],
    fields: {
      potentialDiscountBreakdown: { merge: mergeArrayOfUnnormalizedObjects },
      wheelCosts: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  MarketingNotification: { keyFields: ["id"] },
  MarketplacePreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketplacePromotionalEvent: { keyFields: ["id"] },
  MarketplacePromotionalEvents: { keyFields: ["id"] },
  MarketplaceSportPreferences: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { preferences: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  MaximumCardsCountOwnedByUser: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Membership: { keyFields: ["id"] },
  MissedAppearance: { keyFields: ["id"] },
  MissedLineup: { keyFields: ["slug"] },
  MissedLineupNotification: { keyFields: ["id"] },
  MonetaryAmount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MonetaryReward: { keyFields: ["id"] },
  MonetaryRewardConfig: { keyFields: ["id"] },
  Mutation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NBACard: { keyFields: ["slug"], fields: { collectionScoringMatrix: { merge: mergeArrayOfUnnormalizedObjects } } },
  NBAPlayer: {
    keyFields: ["slug"],
    fields: {
      allAverageStats: { merge: mergeArrayOfUnnormalizedObjects },
      allTotalStats: { merge: mergeArrayOfUnnormalizedObjects },
      cardSupply: { merge: mergeArrayOfUnnormalizedObjects },
      news: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  NBAUserSportProfile: {
    keyFields: ["id"],
    fields: { tournamentEligibilities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  NationalTeam: { keyFields: ["slug"] },
  Nationality: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NoCardRoute: { keyFields: ["id"] },
  Node: { keyFields: ["id"] },
  NotificationInterface: { keyFields: ["id"] },
  NotificationPreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NotificationSection: {
    keyFields: ["slug"],
    fields: { myNotificationPreferences: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  NotificationSubsection: { keyFields: ["slug"] },
  Notifications: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OAuthAccessToken: { keyFields: ["id"] },
  OAuthApplication: { keyFields: ["id"] },
  OfferNotification: { keyFields: ["id"] },
  OnboardingLeaderboard: { keyFields: ["id"] },
  OrderedPlayerGameScores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OrderedSo5Scores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OtherBankAccount: { keyFields: ["id"] },
  OverperformAverageScoreConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OwnedSinceRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  Owner: { keyFields: ["id"] },
  OwnerInterface: { keyFields: ["id"] },
  OwnerWithRates: { keyFields: ["id"] },
  Pack: { keyFields: ["id"] },
  PackSource: { keyFields: ["id"] },
  PageInfo: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Passkey: { keyFields: ["id"] },
  PasskeyChallenge: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PasswordEncryptedPrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Payment: { keyFields: ["id"] },
  PaymentDepositStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaymentMethod: { keyFields: ["id"] },
  PaymentRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaypalAuthorizationRequest: { keyFields: ["id"] },
  PendingDeposit: { keyFields: ["id"] },
  PeriodScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PickableCard: { keyFields: ["slug"] },
  PickablePlayer: { keyFields: ["slug"] },
  PickableTeam: { keyFields: ["slug"] },
  PictureFrameShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Player: {
    keyFields: ["slug"],
    fields: {
      allAverageStats: { merge: mergeArrayOfUnnormalizedObjects },
      allTotalStats: { merge: mergeArrayOfUnnormalizedObjects },
      cardSupply: { merge: mergeArrayOfUnnormalizedObjects },
      news: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  PlayerGameScore: {
    keyFields: ["id"],
    fields: {
      allAroundStats: { merge: mergeArrayOfUnnormalizedObjects },
      detailedScore: { merge: mergeArrayOfUnnormalizedObjects },
      negativeDecisiveStats: { merge: mergeArrayOfUnnormalizedObjects },
      positiveDecisiveStats: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  PlayerGameScoreInterface: {
    keyFields: ["id"],
    fields: { detailedScore: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  PlayerGameScoreProjection: { keyFields: ["id"] },
  PlayerGameStats: { keyFields: ["id"] },
  PlayerGameStatsBaseball: { keyFields: ["id"] },
  PlayerGameStatsBasketball: { keyFields: ["id"] },
  PlayerHeightRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  PlayerRecommendation: { keyFields: ["id"] },
  PlayerWithSupply: { keyFields: ["slug"] },
  PlayingStatusOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PoolKeyShardsCount: { keyFields: ["slug"] },
  PostalAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PotentialDiscountBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerPointsBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PreRegistrationData: { keyFields: ["id"] },
  PrimaryOfferSource: { keyFields: ["id"] },
  PrintablePlayerSource: { keyFields: ["id"] },
  PrivateAccount: { keyFields: ["id"] },
  PrivateEmptyAccount: { keyFields: ["id"] },
  PrivateFiatWalletAccount: { keyFields: ["id"] },
  PrivateKeyRecoveryOption: { keyFields: ["id"] },
  PrivateKeyRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundle: { keyFields: ["id"] },
  ProbabilisticBundleConfig: { keyFields: ["id"], fields: { slots: { merge: mergeArrayOfUnnormalizedObjects } } },
  ProbabilisticBundleConfigSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundleOpeningDisclaimer: { keyFields: ["slug"] },
  ProbabilisticBundleReward: { keyFields: ["id"] },
  ProbabilisticBundleRewardConfig: { keyFields: ["id"] },
  ProbabilisticBundleSlotArenaTicketItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardShardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotConfig: {
    keyFields: ["id"],
    fields: {
      cards: { merge: mergeArrayOfUnnormalizedObjects },
      deliverableItems: { merge: mergeArrayOfUnnormalizedObjects },
      rewardShopItems: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  ProbabilisticBundleSlotConversionCreditItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotDeliverableItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotInGameCurrencyItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotItemInterface: { keyFields: ["id"] },
  ProbabilisticBundleSlotRewardShopItem: { keyFields: ["id"] },
  ProbabilisticBundleSource: { keyFields: ["id"] },
  ProbabilisticBundlesRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { rarities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ProbablePitchersForGameWeek: { keyFields: ["slug"] },
  ProbableRewardConfig: { keyFields: ["id"] },
  ProgressionForRewardConfigThresholds: {
    keyFields: ["id"],
    fields: { thresholds: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  PromotionalEventCompletion: { keyFields: ["id"] },
  PromotionalEventInterface: { keyFields: ["slug"] },
  PublicUserInfoInterface: {
    keyFields: ["slug"],
    fields: {
      competitionCardCollections: { merge: mergeArrayOfUnnormalizedObjects },
      podiums: { merge: mergeArrayOfUnnormalizedObjects },
      searchCardFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
      trophies: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  PurchasableItemInterface: { keyFields: ["slug"] },
  Query: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      cardPullConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      competitionGames: { merge: mergeArrayOfUnnormalizedObjects },
      searchCardFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
      searchPlayerFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  RaffleShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Range: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Rates: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RecommendedConversionCreditTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  Referral: { keyFields: ["id"] },
  ReferralChallengeStats: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralConversionCreditConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralLeaderboard: { keyFields: ["id"] },
  ReferralLeaderboardRanking: { keyFields: ["id"] },
  ReferralPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralProgramConfig: { keyFields: ["id"] },
  ReferralReward: { keyFields: ["id"] },
  ReferralRewardNotification: { keyFields: ["id"] },
  ReferralSpecialEvent: { keyFields: ["id"] },
  ReferralSpecialEventChallenge: { keyFields: ["id"] },
  ReferralTile: { keyFields: ["id"] },
  RejectedCraftSource: { keyFields: ["id"] },
  ReminderNotification: { keyFields: ["id"] },
  RevealCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RevealableCardCampaign: { keyFields: ["slug"] },
  RevealableCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { revealedEditionsConfig: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  RevealedCardsSummary: { keyFields: ["id"] },
  RevealedEditionsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardCard: { keyFields: ["id"] },
  RewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { cards: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  RewardConfigThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardDeliverableItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardMultiplierConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { cardBoosts: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  RewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { experiencesDetails: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  RoomsConfig: { keyFields: ["slug"] },
  SaleNotification: { keyFields: ["id"] },
  ScoringMatrix: { keyFields: ["id"], fields: { statCustomScorings: { merge: mergeArrayOfUnnormalizedObjects } } },
  ScreenshottableCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SealingConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { fullRarityVaultMatrix: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchCardHit: { keyFields: ["slug"] },
  SearchCardHits: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { facets: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchCardSale: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { facets: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchFacet: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { values: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchFacetValue: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { group: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchGroupValue: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroupedCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { facets: { merge: mergeArrayOfUnnormalizedObjects }, groups: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchPlayers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { facets: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SearchProcessingTime: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Season: { keyFields: ["id"] },
  SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonPicture: { keyFields: ["id"] },
  ShopItem: { keyFields: ["id"], fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } } },
  ShopItemInterface: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ShopItemNotification: { keyFields: ["id"] },
  ShopItemReward: { keyFields: ["id"] },
  ShopItemRewardConfig: { keyFields: ["id"] },
  SignInMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignInWithOAuthMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignUpMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SignedCardPrice: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SkinShopItem: {
    keyFields: ["id"],
    fields: { cardCollectionRequirements: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5ActiveClubsBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ActiveClubsRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5ActiveNationalTeamsRule: {
    keyFields: ["id"],
    fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5AgeRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5Appearance: { keyFields: ["id"] },
  So5AppearanceInterface: { keyFields: ["id"] },
  So5AppearancePreview: { keyFields: ["id"] },
  So5AppearancesRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5AtLeastOfClubs: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5AtLeastOfCompetitions: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5AverageScoresBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AverageScoresRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5BoostBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Campaign: { keyFields: ["slug"], fields: { sections: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5CampaignSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { items: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5CampaignSectionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5CaptainScarcityRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5CardEditionsCountRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5CardRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CardShardsEntryItem: { keyFields: ["id"] },
  So5CollectionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Competition: { keyFields: ["slug"] },
  So5CompetitionsRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5Config: { keyFields: ["id"] },
  So5DeliverableItemReward: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5DifferentNationalitiesBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5EntryItemInterface: { keyFields: ["id"] },
  So5EntryItemRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5Fixture: {
    keyFields: ["slug"],
    fields: {
      myBoostedRewardConfigsByRarity: { merge: mergeArrayOfUnnormalizedObjects },
      orderedPlayerGameScores: { merge: mergeArrayOfUnnormalizedObjects },
      orderedSo5Scores: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5FixturePreparing: { keyFields: ["slug"] },
  So5FixturePublicInterface: { keyFields: ["slug"] },
  So5GradeBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Leaderboard: {
    keyFields: ["slug"],
    fields: {
      lineupLiveFeedbacksRules: { merge: mergeArrayOfUnnormalizedObjects },
      possibleBenchSortingTypes: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5LeaderboardContender: { keyFields: ["slug"] },
  So5LeaderboardEntryItemSource: { keyFields: ["id"] },
  So5LeaderboardGroup: { keyFields: ["slug"] },
  So5LeaderboardGroupInterface: { keyFields: ["slug"] },
  So5LeaderboardTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5LeaderboardTaskInterface: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5League: {
    keyFields: ["slug"],
    fields: {
      orderedPlayerGameScores: { merge: mergeArrayOfUnnormalizedObjects },
      orderedSo5Scores: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5LeagueTrack: { keyFields: ["slug"] },
  So5LeagueTrackGroup: { keyFields: ["slug"] },
  So5Lineup: { keyFields: ["id"] },
  So5LineupBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupImport: { keyFields: ["id"], fields: { appearances: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5LineupImportsBatch: { keyFields: ["id"] },
  So5LineupNotification: { keyFields: ["id"] },
  So5LineupPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      consumedEnergies: { merge: mergeArrayOfUnnormalizedObjects },
      feedbackRules: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5LineupSimulatedResult: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupSimulatedResults: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { simulatedResults: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5MalusAfterTransferBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MaximumPlayersAverageScoreRule: {
    keyFields: ["id"],
    fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5MinimumPlayersAverageScoreRule: {
    keyFields: ["id"],
    fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5NationalityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NationalityRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5NoCardAppearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NoCardDraftableAppearance: { keyFields: ["id"] },
  So5NoCardLineup: { keyFields: ["id"], fields: { appearances: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5NoCardRouteFixturePickConfig: {
    keyFields: ["id"],
    fields: { pickingSlots: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5NoCardRoutePickingSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NotNationalityRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5OnboardingPromotionalEvent: { keyFields: ["id"] },
  So5PlayerBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PlayerLoyaltyRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Podium: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionStacksBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PotentialRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Ranking: { keyFields: ["id"] },
  So5RankingsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Rarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RarityVaultRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Reward: {
    keyFields: ["slug"],
    fields: {
      alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      deliverableItems: { merge: mergeArrayOfUnnormalizedObjects },
      rewardShopItems: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5RewardCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardConfig: {
    keyFields: ["id"],
    fields: {
      cards: { merge: mergeArrayOfUnnormalizedObjects },
      deliverableItems: { merge: mergeArrayOfUnnormalizedObjects },
      experiences: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5RewardConfigLock: {
    keyFields: ["slug"],
    fields: { lineupLiveFeedbacksRules: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5RewardConfigWithEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardExperience: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardSource: { keyFields: ["id"] },
  So5RewardTargetConfig: { keyFields: ["slug"] },
  So5Root: { keyFields: ["id"], fields: { cardXpGradeThreshold: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5RuleDescription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { items: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  So5RuleDescriptionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleFeedback: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleInterface: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5Rules: { keyFields: ["id"], fields: { activeClubStacks: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5SameActiveClubBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SameActiveClubRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5ScarcityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ScarcityRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  So5Score: {
    keyFields: ["id"],
    fields: {
      allAroundStats: { merge: mergeArrayOfUnnormalizedObjects },
      detailedScore: { merge: mergeArrayOfUnnormalizedObjects },
      negativeDecisiveStats: { merge: mergeArrayOfUnnormalizedObjects },
      positiveDecisiveStats: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SeasonBonusRule: {
    keyFields: ["id"],
    fields: {
      descriptions: { merge: mergeArrayOfUnnormalizedObjects },
      immuneCountByRarity: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  So5SpecialEditionCardBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Tournament: { keyFields: ["id"] },
  So5Trophies: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroup: { keyFields: ["slug"] },
  So5UserGroupMembership: { keyFields: ["id"] },
  So5UserGroupMembershipsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroupNotification: { keyFields: ["id"] },
  So5UserGroupTournament: { keyFields: ["id"] },
  SocialPictureDerivative: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaAccount: { keyFields: ["id"] },
  SolanaBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaTokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SorarePrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SortingType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SpecialEditionPromotionalEvent: {
    keyFields: ["slug"],
    fields: { revealableCardConfig: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  SpecialWeeklyBanner: { keyFields: ["slug"] },
  SportSeason: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SportStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StageGroup: { keyFields: ["id"] },
  StarPackTask: { keyFields: ["id"], fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } } },
  StarkexLimitOrderAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexV6TokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkwareAccount: { keyFields: ["id"] },
  StarkwarePrivateAccount: { keyFields: ["id"] },
  StarkwareWithdrawal: { keyFields: ["id"] },
  StartingLineupRevealedActivity: {
    keyFields: ["id"],
    fields: { reactions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  StatCustomScoring: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StatScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Stats: { keyFields: ["id"] },
  Story: { keyFields: ["id"] },
  StripeCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Subscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SubstitutionEvent: { keyFields: ["id"] },
  Suspension: { keyFields: ["id"] },
  Task: { keyFields: ["id"], fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } } },
  TaskAppearance: { keyFields: ["id"] },
  TaskAppearanceInterface: { keyFields: ["id"] },
  TaskCampaign: { keyFields: ["slug"], fields: { detailSections: { merge: mergeArrayOfUnnormalizedObjects } } },
  TaskCampaignDetailSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageCampaign: { keyFields: ["slug"] },
  TaskCampaignsHomepageTutorial: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageTutorialSection: { keyFields: ["slug"] },
  TaskConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskGroup: { keyFields: ["slug"] },
  TaskInterface: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  TaskLineupInterface: { keyFields: ["id"] },
  TaskNotification: { keyFields: ["id"] },
  TaskSource: { keyFields: ["id"] },
  TasksTrack: { keyFields: ["id"], fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } } },
  TeamFormation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TeamGameStatsInterface: { keyFields: ["id"], fields: { stats: { merge: mergeArrayOfUnnormalizedObjects } } },
  TeamInterface: { keyFields: ["slug"] },
  TeamVariantStock: { keyFields: ["id"] },
  TeamsPlayingNextGameWeek: { keyFields: ["slug"] },
  ThreeDimensionalAsset: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThreeDimensionalCardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdPickerTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ThresholdPickerTaskAppearance: { keyFields: ["id"] },
  ThresholdPickerTaskLineup: { keyFields: ["id"] },
  ThresholdStreakTaskCurrentThresholdStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdStreakTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdsDuoConnectionTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ThresholdsStreakAdditionalLineupTask: {
    keyFields: ["id"],
    fields: { alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  ThresholdsStreakTask: {
    keyFields: ["id"],
    fields: {
      alternativeRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects },
      thresholds: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  TicketsDeliverableItem: { keyFields: ["slug"] },
  TitleBodyNotificationMobileRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TitleBodyNotificationRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenAuction: { keyFields: ["id"], fields: { bidToEarnRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } } },
  TokenBid: { keyFields: ["id"] },
  TokenDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenMonetaryReward: { keyFields: ["id"] },
  TokenMyBid: { keyFields: ["id"] },
  TokenOffer: { keyFields: ["id"] },
  TokenOfferSide: { keyFields: ["id"] },
  TokenOperationTradeInterface: { keyFields: ["id"] },
  TokenOwner: { keyFields: ["id"] },
  TokenPrice: { keyFields: ["id"] },
  TokenPrimaryOffer: { keyFields: ["id"] },
  TokenRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      topGainers: { merge: mergeArrayOfUnnormalizedObjects },
      topVolume: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  TokenWithdrawal: { keyFields: ["id"] },
  TopGainers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TopVolume: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TournamentCalendarStage: { keyFields: ["id"] },
  TournamentEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TradedPlayer: { keyFields: ["id"] },
  TrophiesSummary: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UnblockEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  UnknownSource: { keyFields: ["id"] },
  UsBankAccount: { keyFields: ["id"] },
  UsedInSo5Lineups: { keyFields: ["slug"] },
  UsedInTaskLineups: { keyFields: ["slug"] },
  UsedInTasks: { keyFields: ["slug"] },
  User: {
    keyFields: ["slug"],
    fields: {
      competitionCardCollections: { merge: mergeArrayOfUnnormalizedObjects },
      podiums: { merge: mergeArrayOfUnnormalizedObjects },
      searchCardFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
      trophies: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  UserAccountEntry: { keyFields: ["id"] },
  UserAward: { keyFields: ["slug"] },
  UserAwardNotification: { keyFields: ["id"] },
  UserCardCollection: { keyFields: ["id"] },
  UserCardCollectionSlot: { keyFields: ["slug"] },
  UserCardsCount: { keyFields: ["slug"] },
  UserDevice: { keyFields: ["id"] },
  UserDeviceEvent: { keyFields: ["id"] },
  UserError: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UserFixtureResults: { keyFields: ["slug"] },
  UserFlag: { keyFields: ["id"] },
  UserGroupCreatedActivity: { keyFields: ["id"], fields: { reactions: { merge: mergeArrayOfUnnormalizedObjects } } },
  UserGroupInterface: { keyFields: ["slug"] },
  UserGroupMemberJoinedActivity: {
    keyFields: ["id"],
    fields: { reactions: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  UserGroupMembershipInterface: { keyFields: ["id"] },
  UserGroupMembershipShopItemsUpdate: { keyFields: ["id"] },
  UserGroupRankedActivity: { keyFields: ["id"], fields: { reactions: { merge: mergeArrayOfUnnormalizedObjects } } },
  UserOwner: { keyFields: ["id"] },
  UserProfile: { keyFields: ["id"], fields: { marketplacePreferences: { merge: mergeArrayOfUnnormalizedObjects } } },
  UserProfileBadge: { keyFields: ["slug"] },
  UserRankingInterface: { keyFields: ["id"] },
  UserRelation: { keyFields: ["id"] },
  UserRelationNotification: { keyFields: ["id"] },
  UserSettings: { keyFields: ["id"], fields: { notificationPreferences: { merge: mergeArrayOfUnnormalizedObjects } } },
  UserShopItem: { keyFields: ["id"] },
  UserSource: { keyFields: ["id"] },
  UserSportProfileInterface: {
    keyFields: ["id"],
    fields: { tournamentEligibilities: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  UserSportStatistic: { keyFields: ["id"] },
  UserWallet: { keyFields: ["id"], fields: { privateKeyRecoveryPayloads: { merge: mergeArrayOfUnnormalizedObjects } } },
  UserWithSubscriptionSlug: {
    keyFields: ["slug"],
    fields: {
      competitionCardCollections: { merge: mergeArrayOfUnnormalizedObjects },
      podiums: { merge: mergeArrayOfUnnormalizedObjects },
      searchCardFacetValues: { merge: mergeArrayOfUnnormalizedObjects },
      trophies: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  UsersFixtureResultsPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Validity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VariantStockCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VaultPointsRule: { keyFields: ["id"], fields: { descriptions: { merge: mergeArrayOfUnnormalizedObjects } } },
  Venue: { keyFields: ["id"] },
  VerificationSession: { keyFields: ["id"] },
  Watchlist: { keyFields: ["slug"], fields: { searchPlayerFacetValues: { merge: mergeArrayOfUnnormalizedObjects } } },
  WearableDeliverableItem: { keyFields: ["slug"] },
  WheelConfig: { keyFields: ["slug"], fields: { bidToEarnRewardConfigs: { merge: mergeArrayOfUnnormalizedObjects } } },
  WheelCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WinningLineup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithNotifications: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithSubscriptionsInterface: { keyFields: ["slug"] },
  Withdrawal: { keyFields: ["id"] },
  WithdrawalWithRates: { keyFields: ["id"] },
  XPCooldownPromotionalEvent: { keyFields: ["slug"] },
  acceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acceptSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  acceptSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  activateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addRecommendedLineupToCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addSolanaAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addToCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addToWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addTokensToDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  addWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  approveMigratorPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  bidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  blockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  buyCardPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  buyDeliverableShopItemPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  buyShopItemPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelEthBankWithdrawalsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  cancelWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  celebrateActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  changePasswordPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  checkPhoneNumberVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimAnyRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimCardsFromPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimConversionCreditPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimDeliverableItemOrderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimFootballManagerTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimOnboardingEnergyGiftPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: {
      errors: { merge: mergeArrayOfUnnormalizedObjects },
      giftedEnergies: { merge: mergeArrayOfUnnormalizedObjects },
    },
  },
  claimPromotionalEventAirdropPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimReferralRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimRewardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimStarterPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  claimTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  completeDropChallengePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmDeviceWithCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5LineupsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  confirmSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  consumeCardBoosterPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCardAuthorizationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCardRegistrationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createConnectedTasksPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createCryptoDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDepositBankAccountMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createDirectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEphemeralLinkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthBankWithdrawalIntentPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthMigrationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createEthVaultPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatPayerPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createFiatWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createIdentityVerificationSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createJwtTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOnboardingSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createOrUpdateSingleBuyOfferMinPricePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createPasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSingleSaleOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWireTransferDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  createWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deactivateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  declineSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  declineSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deletePasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deletePostalAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteTaskLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  deleteWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  depositWithApplePayPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyReferralPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  destroyWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  detachPaymentMethodPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  disable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  disconnectOmniauthProviderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  dropAndAddCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  editDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  enable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  enrollSCAPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  fetchEncryptedPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateAccountingExtractPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateOtpBackupCodesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateOtpProvisioningUriPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generatePasskeyChallengeForCreatePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generatePasskeyChallengeForSignInPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  generateSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  hideMyFeaturedSo5LeaderboardGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  joinSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  levelUpCardWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  levelUpCardsWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  linkEthereumAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  loadPreviousLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  loadSuggestedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  lockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markCardShardsChestUnlockedThresholdAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markItemAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markNotificationsAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  markStoriesAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  migrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  pickPulledCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareAcceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareAcceptTradeWithWalletAndCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareBuyInGameCurrencyPackWithCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareIdealDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareMigrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  preparePaypalDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  prepareTokenDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  probabilisticBundlesOpenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  pullCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reactActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  refreshCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  rejectCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  rejectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  relayCallPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeFromCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeFromWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeTokenFromDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  removeUserFromSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  reportTelemetryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  requestSo5NoCardLineupEligibleLeaderboardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resendConfirmationInstructionsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resendVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resetPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  resetSo5NoCardDraftedAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  restartTasksTrackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  restoreWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revealBlueprintsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revealPropertyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeOAuthAccessTokenForApplicationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  revokeOAuthAccessTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  saveForLaterPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  sealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  sendWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setDeviceTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  setTokenTradeStatusPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  signOutFromAllDevicesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  skipOnboardingPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  spendCardShardsChestPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  spinWheelPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  stopAutoBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  storeApplePurchaseTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  suggestLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unblockFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unblockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unlockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  unsealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateCardFiltersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateExternalEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateFavoriteTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateHighlightedCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateManagerTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateOnboardingSo5LeaderboardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updatePartnerOffersAgreementPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSectionNotificationPreferencesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSo5LineupSettingsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSportProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  updateUserSettingsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertTaskAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertTaskLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  upsertWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  validateApplePayMerchantSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  validateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyInGameCurrencyPackMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  verifyPhoneNumberPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
  visitCampaignPagePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
    fields: { errors: { merge: mergeArrayOfUnnormalizedObjects } },
  },
};
